import { createSlice } from '@reduxjs/toolkit';

import { createManyBreeding, updateBreeding } from '../actions/breedingSlice';

const breedingSlice = createSlice({
  name: 'breeding',
  initialState: {
    data: null,
    error: null,
    loading: false
  },
  extraReducers: builder => {
    builder
      // Update Breeding
      .addCase(updateBreeding.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateBreeding.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateBreeding.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Create Many Breeding
      .addCase(createManyBreeding.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createManyBreeding.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createManyBreeding.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default breedingSlice.reducer;
